// extracted by mini-css-extract-plugin
export default {"block":"cuUIf","icon":"PngVZ","title":"DUaj3","message":"UOddN"};